import React from 'react'
import PropTypes from 'prop-types'
import styled, { createGlobalStyle } from 'styled-components'
import { useUserContext } from '@hooks/useUserContext'
import CommonIconButton from './CommonIconButton'
import CommonText from './CommonText'

const CommonSidebar = ({ openMenu }) => {
  const { state, handleLogout } = useUserContext()

  const logOut = () => {
    openMenu()
    handleLogout()
  }

  return (
    <aside>
      <SidebarStyle />
      <Mask onClick={openMenu} />
      <div className="sideBar-wrapper">
        <CommonIconButton
          className="sidebar-close"
          iconButtonType="back"
          onClick={openMenu}
          style={{
            cursor: 'pointer',
          }}
        />
        {state.token && (
          <>
            <CommonText
              link="/main"
              tag="a"
              className="sidebar-link"
              style={{
                marginTop: '50px',
              }}
              fontSize={20}
              fontWeight={700}
              onClick={openMenu}>
              My 피드
            </CommonText>
            <CommonText
              link="/user"
              tag="a"
              className="sidebar-link"
              fontSize={20}
              fontWeight={700}
              onClick={openMenu}>
              My 레시피
            </CommonText>
            <CommonText
              link="/userinfo"
              tag="a"
              className="sidebar-link"
              fontSize={20}
              fontWeight={700}
              onClick={openMenu}>
              비밀번호 변경
            </CommonText>
            <CommonText
              tag="span"
              className="sidebar-link"
              fontSize={20}
              fontWeight={700}
              onClick={logOut}>
              로그아웃
            </CommonText>
          </>
        )}
      </div>
    </aside>
  )
}

CommonSidebar.propTypes = {}

const SidebarStyle = createGlobalStyle`
.sideBar-wrapper {
  position: fixed;
  top: 0;
  right: calc((100% - 640px) / 2);
  bottom: 0;
  width: 400px;
  height: 100%;
  padding-left: 30px;
  z-index: 3;
  box-sizing: border-box;
  background-color: #ffffff;
}

.sidebar-close {
  margin-top: 100px;
  transform: rotate(0.5turn);
}

.sidebar-link {
  display: block;
  margin-top: 30px;
  cursor: pointer;
}
`

const Mask = styled.div`
  position: fixed;
  min-width: 320px;
  max-width: 640px;
  height: 100%;
  top: 0;
  left: calc((100% - 640px) / 2);
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2;
`

export default CommonSidebar
